import LocalizedStrings from "react-localization";
import localization from "./localization";
import { useAppState } from "./AppState";

export default function useTranslation() {
    const [{ language }] = useAppState();
    let translation = new LocalizedStrings(localization);

    translation.setLanguage(language);
    return translation;
}